import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import "./tokens.css";
import "./app.css";

const root = document.getElementById("root");
if (!root) throw new Error("нет #root");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
